<div *ngFor="let item of getAppList()" class="p-2">
    <div class="panel">
        <app-application-list-item [item]="item" [applistType]="applistType"></app-application-list-item>
    </div>
</div>

<div class="py-4" *ngIf="getAppList().length == 0">
    <div class="panel text-center">
        No applications found.
    </div>
</div>